import styled from 'styled-components';
import { Button, Input } from 'reactstrap';

export const ButtonLogin = styled(Button)`
  width: 100%;
  border-radius: 40px;
  text-align: left;
  padding: 10px 25px;
  border: none;
  font-family: 'Raleway', sans-serif;
  font-weight: 600;
  font-size: 20px;
  height: 46px;
  background: #0C2B6E;
  position: relative;
  transition: all 0.6s ease-in-out;
  
  &:hover {
    background-color: #0056b3;
    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.2);
    transform: scale(1.01);
  }
  svg {
    position: absolute;
    right: 25px;
    top: 15px;
  }

  @media (max-width: 767px) {
    font-size: 16px;
    height: 45px;
    padding: 8px 20px;
  }
`;

export const RegisterLink2 = styled.a`
  cursor: pointer;
  color: #0C2B6E;
  font-family: 'Raleway', sans-serif;
  font-weight: 650;
  text-decoration: underline;
  @media (max-width: 768px) {
    font-size: 16px;  /* Ajuste o tamanho da fonte para telas menores */
  
  }
`;

export const SpanText = styled.span`
 color: rgba(0, 0, 0, 0.9);
 font-weight: 400;
 margin: 15px 0;
 font-size: 13px;  /* Ajuste o tamanho da fonte para telas menores */

  @media (max-width: 768px) {
    font-size: 13px;  /* Ajuste o tamanho da fonte para telas menores */
  }
`;



export const InputLogin = styled(Input)`
  height: 46px;
  width: 100%; /* 100% da largura do container pai */
  max-width: 400px; /* Limita a largura máxima */
  border-radius: 40px;
  text-align: left;
  padding: 10px 25px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-size: 16px;
  margin-top: 10px; /* Espaço entre os 
  @media (max-width: 767px) {
    font-size: 14px; /* Reduz o tamanho da fonte em telas pequenas */
    padding: 10px 20px; /* Ajusta o padding para ser mais confortável */
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center; /* Centraliza horizontalmente */
  justify-content: center; /* Centraliza verticalmente */
 /*  height: 35vh; /* Ocupa toda a altura da tela */ */
  height: auto; /* Evita que o formulário ultrapasse a tela */
    padding: 0 10px;
  width: 100%; /* Ocupa toda a largura do pai */

  position: relative; /* Adiciona um contêiner de posicionamento relativo */
  h1 {
    color: #0C2B6E;
    font-family: 'Raleway', sans-serif;
    margin: 20px 0;
    font-weight: 700;
    
  }
  @media (max-width: 900px) {
    height: auto; /* Evita que o formulário ultrapasse a tela */
    padding: 20px 10px;
  }
`;
export const LinksContainer = styled.div`
  display: flex;
  flex-direction: row; /* Alinha os links horizontalmente */
  justify-content: center; /* Alinha os links ao centro */
  width: 100%;
  margin: 15px 0;
  align-items: center; /* Alinha os links verticalmente no centro */
  @media (max-width: 767px) {
    flex-direction: column; /* Coloca os links um abaixo do outro em telas pequenas */
    gap: 15px; /* Ajuste do espaçamento entre os links */
  }
`;

export const SecurityNotice = styled.div`
  z-index: 1050;
  background-color: rgba(52, 58, 64, 0.8); /* cinza escuro */
  color: #f8f9fa; /* texto claro */
  padding: 15px 24px;
  width: 100%;
  max-width: 640px;
  font-size: 13px;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.6);

  /* 🟢 Adicione isso para centralizar */
  align-self: center; /* Centraliza dentro de um flex container */
  margin: 10px auto;  /* Garante centralização horizontal */

  display: flex;
  flex-direction: column;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    h4 {
      margin: 0;
      font-size: 15px;
      display: flex;
      align-items: center;
      gap: 5px;
      color: #ffffff;
    }

    .close-btn {
      color: #adb5bd;
      font-size: 16px;
      padding: 0;
      line-height: 1;

      &:hover {
        color: rgb(222, 226, 230);
      }
    }
  }

  p {
    margin: 6px 0;
    line-height: 1.5;
    color: #dee2e6;
  }

  strong {
    color: #ffffff;
    font-weight: 600;
  }

  a {
    color: #f8f9fa;
    text-decoration: underline;

    &:hover {
      color: #ced4da;
    }
  }

  @media (max-width: 576px) {
    padding: 16px;
    font-size: 13px;
  }
`;



export const ForgotPassLink = styled.span`
  display: flex;
  align-items: center; /* Garante que o ícone e o texto fiquem alinhados verticalmente */
  justify-content: center;
  cursor: pointer;
  color: #0C2B6E;
  font-family: 'Raleway', sans-serif;
  font-weight: 700;
  font-size: 17px;
  text-decoration: underline;
  gap: 5px; /* Adiciona um espaço consistente entre o texto e o ícone */
  margin: 18px 0;
  span {
    display: flex;
    align-items: center; /* Alinha o ícone com o texto */
  }

  @media (max-width: 1330px) {
    font-size: 16px;

    gap: 4px; /* Ajuste o gap para dar um pouco de espaçamento entre o texto e o ícone */
  }
`;

export const EyeIcon = styled.div`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 20px;
  color: #555;

  svg {
    margin-right: 5px;
  }
`;







export const RegisterBox = styled.div`
  border-radius: 15px;
  background-color: #f2f2f2;
  margin-top: 35px;
  width: 72%;
  padding: 10px;
  text-align: left; /* Alinha conteúdo interno à esquerda */
  display: flex;
  flex-direction: column;

  h4 {
    color: #0C2B6E;
    font-size: 21.5px;
    margin: 0 0 8px 0; /* Margem embaixo do h4 para dar espaço sutil */
    font-weight: 600;
  }

  span {
    font-size: 17px;
    color: #0C2B6E;
    width: 100%; /* Faz o span ocupar o espaço inteiro */
    display: block; /* Garante que ele se comporte como bloco */
  }

  @media (max-width: 460px) {
    width: 95%;
  }
`;


export const ButtonRegister = styled(Button)`
  color: white;
  border-radius: 10px;
  border: none;
  font-family: 'Raleway', sans-serif;
  font-weight: 500;
  font-size: 17px;
  background: #0C2B6E;
  white-space: normal;
  line-height: 1.4;
  min-height: 40px;
  padding: 5px 10px;
margin-top:15px;

  width: 100%; /* ocupa todo o espaço do RegisterBox (igual ao texto) */

  @media (max-width: 768px) {
    font-size: 16px;
    min-height: 60px;
    padding: 12px 10px;
  }

  @media (max-width: 460px) {
    font-size: 17px;
    min-height: 40px;
    padding: 2px 10px;
  }
`;
